/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AcknowledgeStationAlarm$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The tag ID. Must be a valid ID.
 */
  alarmUid: string;
}

export function acknowledgeStationAlarm(http: HttpClient, rootUrl: string, params: AcknowledgeStationAlarm$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, acknowledgeStationAlarm.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('alarmUid', params.alarmUid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

acknowledgeStationAlarm.PATH = '/stations/{uid}/alarms/{alarmUid}/ack';
